<template>
  <div class="sender-info">
    <template v-if="parsed">
      <div class="info-row" v-if="parsed.lastName || parsed.firstName">
        <span class="label">ФИО:</span>
        <span>{{ [parsed.lastName, parsed.firstName, parsed.middleName].filter(Boolean).join(' ') }}</span>
      </div>
      <div class="info-row" v-if="parsed.birthDate">
        <span class="label">Дата рождения:</span>
        <span>{{ formatDate(parsed.birthDate) }}</span>
      </div>
      <div class="info-row" v-if="parsed.phoneNumber">
        <span class="label">Телефон:</span>
        <span>{{ parsed.phoneNumber }}</span>
      </div>
      <div class="info-row" v-if="parsed.citizenship">
        <span class="label">Гражданство:</span>
        <span>{{ parsed.citizenship }}</span>
      </div>
      <div class="info-row" v-if="parsed.gender">
        <span class="label">Пол:</span>
        <span>{{ parsed.gender === 'MALE' ? 'Мужской' : 'Женский' }}</span>
      </div>
      <template v-if="parsed.documents?.length">
        <div class="info-row" v-for="(doc, i) in parsed.documents" :key="i">
          <span class="label">Документ {{ i + 1 }}:</span>
          <span>Серия {{ doc.series }}, № {{ doc.number }}, выдан {{ doc.issuer }} ({{ formatDate(doc.issueDate) }})</span>
        </div>
      </template>
      <div class="info-row" v-if="parsed.addresses?.registrationAddress?.full">
        <span class="label">Адрес:</span>
        <span>{{ parsed.addresses.registrationAddress.full }}</span>
      </div>
    </template>
    <template v-else>
      {{ value }}
    </template>
  </div>
</template>
<style scoped>
.label {
  margin-right: .25rem;
}
</style>

<script setup lang="ts">
import { computed } from 'vue'

interface SenderDocument {
  type: string
  series: string
  number: string
  issuer: string
  issuerCode: string
  issueDate: string
  countryCode: string
}

interface SenderData {
  firstName?: string
  lastName?: string
  middleName?: string
  birthDate?: string
  gender?: string
  citizenship?: string
  countryOfResidence?: string
  phoneNumber?: string
  documents?: SenderDocument[]
  addresses?: {
    birthPlaceAddress?: { countryCode: string; full: string }
    registrationAddress?: { countryCode: string; full: string }
  }
}

const props = defineProps<{ value: any }>()

const parsed = computed((): SenderData | null => {
  try {
    return props.value
  } catch {
    return null
  }
})

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('ru-RU')
}
</script>